import { render, staticRenderFns } from "./stock-adjustment.vue?vue&type=template&id=96364d74"
import script from "./stock-adjustment.vue?vue&type=script&lang=js"
export * from "./stock-adjustment.vue?vue&type=script&lang=js"
import style0 from "./stock-adjustment.vue?vue&type=style&index=0&id=96364d74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports